"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyPromptPopover = void 0;

const faExclamationCircle_1 = require("@fortawesome/pro-regular-svg-icons/faExclamationCircle");

const react_fontawesome_1 = require("@fortawesome/react-fontawesome");

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const utils_1 = require("../../Common/utils");

const SskyButton_1 = __importDefault(require("../SskyButton"));

const SskyPopover_1 = __importDefault(require("../SskyPopover"));

const PROMPT_TYPE_COLOR_MAP = {
  info: "#2D9CDB",
  warning: "#FF9900",
  error: "#ff3333"
};
const StyledExclamationIcon = (0, material_1.styled)(react_fontawesome_1.FontAwesomeIcon, {
  shouldForwardProp: prop => prop !== "promptType"
})(({
  promptType
}) => ({
  fontSize: 17,
  marginRight: 10,
  verticalAlign: "top",
  marginTop: 3,
  color: PROMPT_TYPE_COLOR_MAP[promptType]
}));
const StyledTitleTypography = (0, material_1.styled)(material_1.Typography)({
  display: "inline-block",
  width: "calc(100% - 27px)",
  fontSize: 18,
  color: "#333333",
  marginBottom: 10
});
const StyledContentContainer = (0, material_1.styled)("div")({
  marginLeft: 27,
  fontSize: 12,
  lineHeight: 28,
  flexGrow: 1
});
const StyledButtonsContainer = (0, material_1.styled)("div")({
  marginTop: 24
});
const StyledSskyButton = (0, material_1.styled)(SskyButton_1.default)({
  float: "right",
  minWidth: 90
});

const SskyPromptPopover = props => {
  return react_1.default.createElement(SskyPopover_1.default, {
    anchor: props.anchor,
    "data-testid": props.dataTestId ? `${props.dataTestId}-popover` : `testId-${props.title}-popover`,
    onClose: props.onClose,
    open: props.open,
    paperStyle: {
      width: 440,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start"
    }
  }, react_1.default.createElement("div", null, props.promptType && react_1.default.createElement(StyledExclamationIcon, {
    icon: faExclamationCircle_1.faExclamationCircle,
    promptType: props.promptType
  }), react_1.default.createElement(StyledTitleTypography, null, (0, utils_1.convertMultilineTextToJSX)(props.title))), react_1.default.createElement(StyledContentContainer, null, react_1.default.createElement(material_1.Typography, null, props.content)), props.children, react_1.default.createElement(StyledButtonsContainer, null, react_1.default.createElement(StyledSskyButton, {
    label: props.positiveButtonText,
    onClick: props.onPositiveClick,
    sx: {
      margin: 0
    },
    autoFocus: true,
    "data-testid": props.dataTestId ? `${props.dataTestId}-positiveButton` : `testId-${props.title}-positiveButton`
  }), props.onNegativeClick && react_1.default.createElement(StyledSskyButton, {
    label: props.negativeButtonText,
    color: "inherit",
    variant: "outlined",
    onClick: props.onNegativeClick,
    sx: {
      margin: "0 10px"
    },
    "data-testid": props.dataTestId ? `${props.dataTestId}-negativeButton` : `testId-${props.title}-negativeButton`
  })));
};

exports.SskyPromptPopover = SskyPromptPopover;
SskyPromptPopover.defaultProps = {
  negativeButtonText: "Cancel",
  positiveButtonText: "OK"
};
exports.default = react_1.default.memo(SskyPromptPopover);